import produce from 'immer';
import { ReducerAction } from 'store/modules/types';
import { Types, consultarAndamentoSolicitacoes } from './types';

export const INITIAL_STATE: consultarAndamentoSolicitacoes = {
	status: 0,
	data: [],
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): consultarAndamentoSolicitacoes {
	return produce(state, draft => {
		switch (action.type) {
			case Types.CONSULTAR_ANDAMENTO_PATERNIDADE_REQUEST: {
				draft.data = INITIAL_STATE.data;
				draft.status = 100;
				break;
			}

			case Types.CONSULTAR_ANDAMENTO_PATERNIDADE_SUCCESS: {
				draft.status = action.payload.status;
				draft.data = action.payload.data;
				break;
			}

			case Types.CONSULTAR_ANDAMENTO_PATERNIDADE_FAILURE: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}
			case Types.CONSULTAR_ANDAMENTO_PATERNIDADE_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			default:
		}
		return draft;
	});
}
